import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeaderPage from '../../components/HeaderPage';
import { useBlogContext } from '../../../fetchdata/BlogContext';

const AccountSupport = () => {
  const { Headers, isHeader } = useBlogContext();

  return (
    <>
      <Header />
      <HeaderPage title="Help & Support" />

      <main className="page-content bg-light py-5">
        <div className="container">
          <div className="row justify-content-center">

            {!isHeader && (
              <>
                {/* Phone Card */}
                <div className="col-md-6 col-lg-4 mb-4">
                  <div className="card shadow-sm border-0 hover-scale">
                    <div className="card-body d-flex align-items-center gap-3 p-4">
                      <div className="icon-circle bg-success text-white d-flex align-items-center justify-content-center">
                        <i className="fa-solid fa-phone-alt "></i>
                      </div>
                      <div>
                        <h5 className="card-title mb-1">Call Us</h5>
                        <p className="card-text fs-6 mb-0">+91 {Headers.phone}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Email Card */}
                <div className="col-md-6 col-lg-4 mb-4">
                  <div className="card shadow-sm border-0 hover-scale">
                    <div className="card-body d-flex align-items-center gap-3 p-4">
                      <div className="icon-circle bg-primary text-white d-flex align-items-center justify-content-center">
                        <i className="fa-solid fa-envelope "></i>
                      </div>
                      <div>
                        <h5 className="card-title mb-1">Email Us</h5>
                        <p className="card-text fs-6 mb-0">{Headers.email}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

          </div>

          {/* Optional: Add a message/contact form here for desktop */}
          <div className="row justify-content-center mt-4">
            <div className="col-lg-8">
              <div className="card shadow-sm border-0 p-4 hover-scale">
                <h5 className="mb-3">Send a Message</h5>
                <form>
                  <div className="mb-3">
                    <label className="form-label">Your Name</label>
                    <input type="text" className="form-control" placeholder="Enter your name" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email Address</label>
                    <input type="email" className="form-control" placeholder="Enter your email" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Message</label>
                    <textarea className="form-control" rows="4" placeholder="Type your message here"></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary">Send Message</button>
                </form>
              </div>
            </div>
          </div>

        </div>
      </main>

      <Footer />

      {/* Custom Styles */}
      <style>
        {`
          .hover-scale {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .hover-scale:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          }
          .icon-circle {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            font-size: 28px;
          }
        `}
      </style>
    </>
  )
}

export default AccountSupport;
